import { Row, Col, Typography, Button } from '../../ui/ot'
import News from '../../news/views/News'
import { ComposedChart, BarChart, Bar, Line, XAxis, YAxis, Cell, CartesianGrid, Tooltip, ResponsiveContainer, LabelList, Legend } from 'recharts';
import { useNavigate } from 'react-router-dom'

const OnlinePublicCatalogQueryConstructionNews = ({
    showChart = true,
    clickToVisitPath = '/online_public_catalog_query_construction/new',
    permission_level = null,
}) => {
    const navigate = useNavigate()

    return (<Row gutter={[20, 20]}>
        <Col span={24}>
            <Row justify={'center'} gutter={[16, 20]}>
                {showChart && <Col lg={12} md={12} sm={24} xs={24}>
                    <BarAndLineChart />
                </Col>}
                {showChart && <Col lg={12} md={12} sm={24} xs={24}>
                    <MyBarChart />
                </Col>}
                <Col span={24}>
                    <News
                        showNewsType={false}
                        propsMode={true}
                        onClickClickToVisit={(news_id)=>{
                            navigate(`./new?news_id=${news_id}`)
                        }}
                        permission_level={permission_level}
                    />
                </Col>
            </Row>
        </Col>
    </Row>)
}
export default OnlinePublicCatalogQueryConstructionNews


const MyBarChart = () => {
    const data = [
        { name: "Google", value: 300, newValue: 200 },
        { name: "Yahoo", value: 280, newValue: 180 },
        { name: "NTUST", value: 450, newValue: 250 },
        { name: "140.118", value: 400, newValue: 220 },
        { name: "Other", value: 150, newValue: 100 },
    ];

    return (
        <Row justify="center" gutter={[24, 24]}>
            <Col xs={24} sm={24} md={22} lg={22} xl={24}>
                <Row justify="space-between" style={{ marginBottom: '16px' }}>
                    <Col>
                        <Typography.Title level={4}>
                            過去半年發佈率
                        </Typography.Title>
                    </Col>
                    <Col>
                        <Button
                            type='default'
                            style={{
                                color: "#fff",
                                backgroundColor: "#1890ff",
                                marginRight: '4px'
                            }}
                            onClick={() => { /* 定義查看更多的功能邏輯 */ }}
                        >
                            查看更多
                        </Button>
                        <Button
                            type='text'
                            style={{
                                color: "#000",
                                backgroundColor: "#56b673"
                            }}
                            onClick={() => {/* getRwdFunctionExcel() */ }}
                        >
                            匯出檔案
                        </Button>
                    </Col>
                </Row>
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend content={<CustomLegend />} layout="vertical" align="right" verticalAlign="middle" />
                        <Bar dataKey="value" fill="#4285F4" name="Value" stackId="a" />
                        <Bar dataKey="newValue" fill="#82ca9d" name="New Value" stackId="a" />
                    </BarChart>
                </ResponsiveContainer>
            </Col>
        </Row>
    );
};
const CustomLegend = ({ payload }) => (
    <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
        {payload.map((entry, index) => (
            <li key={`item-${index}`} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                <span
                    style={{
                        display: 'inline-block',
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%', // Circle shape
                        backgroundColor: entry.color,
                        marginRight: '8px'
                    }}
                />
                {entry.value}
            </li>
        ))}
    </ul>
);

const BarAndLineChart = () => {
    const data = [
        { name: "Google", value: 300, newValue: 200, lineValue: 350 },
        { name: "Yahoo", value: 280, newValue: 180, lineValue: 320 },
        { name: "NTUST", value: 450, newValue: 250, lineValue: 400 },
        { name: "140.118", value: 400, newValue: 220, lineValue: 390 },
        { name: "Other", value: 150, newValue: 100, lineValue: 200 },
    ];

    return (
        <Row justify="center" gutter={[24, 24]}>
            <Col xs={24} sm={24} md={22} lg={22} xl={24}>
                <Row justify="space-between" style={{ marginBottom: '16px' }}>
                    <Col>
                        <Typography.Title level={4}>
                            本週發佈率
                        </Typography.Title>
                    </Col>
                    <Col>
                        <Button
                            type='default'
                            style={{
                                color: "#fff",
                                backgroundColor: "#1890ff",
                                marginRight: '4px'
                            }}
                            onClick={() => { /* 定義查看更多的功能邏輯 */ }}
                        >
                            查看更多
                        </Button>
                        <Button
                            type='text'
                            style={{
                                color: "#fff",
                                backgroundColor: "#56b673"
                            }}
                            onClick={() => {/* getRwdFunctionExcel() */ }}
                        >
                            匯出檔案
                        </Button>
                    </Col>
                </Row>
                <ResponsiveContainer width="100%" height={400}>
                    <ComposedChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend content={<CustomLegend />} layout="vertical" align="right" verticalAlign="middle" />
                        <Bar dataKey="value" fill="#4285F4" name="Value" stackId="a" />
                        <Bar dataKey="newValue" fill="#82ca9d" name="New Value" stackId="a" />
                        <Line type="monotone" dataKey="lineValue" stroke="#ff7300" name="Line Value" />
                    </ComposedChart>
                </ResponsiveContainer>
            </Col>
        </Row>
    );
};